import { createSlice } from "@reduxjs/toolkit";
import { updateUsername } from "./userDetailSlice";

const initialState = {
  isLoggedIn: false,
  sessionid: "",
  verification: false,
  registration: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutUser: (state, action) => {
      state.isLoggedIn = false;
    },
    userLoggedIn: (state, action) => {
      state.isLoggedIn = true;
    },
    updateSessionid: (state, action) => {
      state.sessionid = action.payload;
    },
    updateRegistration: (state, action) => {
      state.registration = action.payload;
    },
    resetAuthSlice: (state, action) => {
      state = initialState;
    },
  },
});

export const {
  logoutUser,
  userLoggedIn,
  updateSessionid,
  updateRegistration,
  resetAuthSlice,
} = authSlice.actions;

export const authReducerNew = authSlice.reducer;
